export const apiSignature = {
    AUTH_LOGIN : "auth/loginAPI",
    AUTH_REGISTER : "auth/fetchSignupAPI",
    AUTH_EMAIL_VERIFY : "auth/emailVerification",
    AUTH_LOGOUT:"auth/logout"

}